import AppDatePicker from '@nxsys/components/AppDatePicker';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import moment from 'moment';
import React from 'react';
import StepCard from './StepCard';

interface AddDOBProps {
  stepNumber: number;
  DOB?: string | null;
  completed?: boolean;
  onSubmitStep: (values: any) => void;
}

type AddDOBValues = {
  dobValue: string;
};

const AddDOB: React.FC<AddDOBProps> = ({
  stepNumber,
  DOB,
  completed = false,
  onSubmitStep,
}) => {
  const [form] = Form.useForm<AddDOBValues>();
  const { messages } = useTypedIntl();

  const onFinish = (values: AddDOBValues) => {
    const params = {
      DOB: values?.dobValue ? moment(values?.dobValue).toISOString() : null,
    };
    onSubmitStep(params);
  };

  return (
    <StepCard
      title={messages['prospect.onboarding.addDOB']}
      stepNumber={stepNumber}
      completed={completed}
      actions={[
        {
          variant: 'outlined',
          name: messages['common.save'] as string,
          onClick: () => form.submit(),
        },
      ]}
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        initialValues={{
          dobValue: DOB,
        }}
        wrapperCol={{ span: 24 }}
        layout="vertical"
      >
        <Form.Item
          label={messages['common.dateOfBirth']}
          name="dobValue"
          rules={[
            {
              required: true,
              message: messages['form.pleaseSelect'],
            },
            {
              validator: (_: any, val: any) => {
                if (!val) return Promise.resolve();
                const age = moment().year() - moment(val).year();
                if (age >= 14) return Promise.resolve();
                return Promise.reject(
                  new Error(messages['validation.dobMinAge']),
                );
              },
            },
          ]}
        >
          <AppDatePicker
            placeholder={messages['form.selectDate']}
            format={'DD/MM/YYYY'}
            // A date of birth can never be in the future.
            disabledDate={(current: moment.Moment) =>
              !!current && current.isAfter(moment(), 'day')
            }
          />
        </Form.Item>
      </AppFormContainer>
    </StepCard>
  );
};

export default AddDOB;
